'use client';

import { Box } from '@radix-ui/themes';
import MobileHeader from '../components/header/mobile-header';
import DesktopHeader from '../components/header/desktop-header';
import { useAppSelector } from '@/app/lib/store/hooks';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { APP_URLS } from '@/app/lib/constants/app-urls';
import { LOGO_HEIGHT } from '@/app/lib/constants/sizes';

export default function HeaderContainer() {
  const router = useRouter();
  const isAtTop = useAppSelector(state => state.scroll.isAtTop);
  const isOpen = useAppSelector(state => state.drawer.isOpen);

  const theme = useAppSelector(state => state.theme.mode);

  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  const user = useAppSelector(state => state.user.data);

  const handleSubscribe = () => {
    router.push(APP_URLS.signUpChoosePlanUrl);
  };
  const handleLogin = () => {
    router.push('/auth');
  };

  const logoHeight = LOGO_HEIGHT.header;

  return (
    <>
      <Box display={{ initial: 'block', md: 'none' }}>
        <MobileHeader
          isAtTop={isAtTop}
          isOpen={isOpen}
          isClient={isClient}
        />
      </Box>
      <DesktopHeader
        isAtTop={isAtTop}
        user={user}
        isClient={isClient}
        onSubscribe={handleSubscribe}
        onLogin={handleLogin}
        theme={theme}
        logoHeight={logoHeight}
      />
    </>
  );
}
